import BenchmarkSearchSection from "./benchmarkSearch/BenchmarkSearchSection"
import CalculatorSection from "./calculator/CalculatorSection"
import CredibilitySection from "./credibility/CredibilitySection"
import FinalConverterSection from "./finalConverter/FinalConverterSection"
import LightFooter from "./footer/LightFooter"
import LightHeader from "./header/LightHeader"
import LeaderboardSection from "./leaderboard/LeaderboardSection"
import { contentColumnClass, pageRootClass } from "./lightTheme"

export default function RoofingSpeedToLeadBenchmarkLanding() {
  return (
    <div className="roofing-light-canvas min-h-screen w-full bg-[#FAFAFA]">
      <LightHeader />
      <div className={`${pageRootClass} pt-0`}>
        <div className={contentColumnClass}>
          <CredibilitySection />
          <BenchmarkSearchSection />
          <LeaderboardSection />
          <CalculatorSection />
          <FinalConverterSection />
        </div>
        <LightFooter />
      </div>
    </div>
  )
}
